module.exports = __webpack_public_path__ + "img/category-gemmology-reverse.ae1f194d.svg";